<template>
  <div class="page">
    <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
      <a-row slot="title" type="flex" justify="space-between">
        <a-col :span="8">
          <span class="card-title">{{ title }}</span>
          <a-button type="primary" @click="addPro(6)">添 加</a-button>
        </a-col>
        <a-col :span="8" class="text-right">
          修改栏目名称或开启自动推荐 &nbsp;&nbsp; <a @click="settingTitle">设置</a>
        </a-col>
      </a-row>
      <a-table
        :columns="columns"
        rowKey="proId"
        :dataSource="specialProList" :pagination="false">
        <div class="image-table" slot="imageSlots" slot-scope="text">
          <CustomImage :imageUrl="text" :width="120"></CustomImage>
        </div>
        <div slot="typeSlots" slot-scope="text">{{ text | productTypeName }}</div>
        <div slot="action" slot-scope="text,record">
          <a-popconfirm
            title="是否要删除当前商品？"
            @confirm="deleteEvent(6,record.proId)">
            <a-icon slot="icon" type="close-circle" style="color: red"/>
            <a>移除商品</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
    <a-modal title="修改栏目名称"
             :visible="visible"
             @ok="handleOk"
             @cancel="visible = false"
    >
      <a-input v-model="setName" :maxLength="8" placeholder="请输入"/>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PrettyProTable',
  props: {
    specialProList: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      setName: '',
      visible: false,
      catalogId: this.$route.query.catalogId,//商品类型
      merchantId: this.$store.getters.userInfo.merchantId,
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '封面图片',
          dataIndex: 'homeImage',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogId',
          scopedSlots: { customRender: 'typeSlots' },
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {

  },
  methods: {
    // 删除
    deleteEvent(modularClassId, proId) {
      let data = new Object()
      data.modularClassId = modularClassId
      data.proId = proId
      this.getLogUtils().logWithTag('deleteEvent', data)
      this.$emit('deletePro', data)
    },
    // 添加商品
    addPro(modularClassId) {
      this.$emit('change', modularClassId)
    },
    settingTitle() {
      this.setName = this.title
      this.visible = true
    },
    handleOk() {
      this.getHttpServices().getUserService().post('user/home/updateModelName', {
        modularClassID: 6,
        modularTitle: this.setName,
        merchantId: this.merchantId,
        proType: this.catalogId,
        modularKey: ''
      }).then(res => {
        this.getLogUtils().logWithTag('==updateModelName==', res)
        this.visible = false
        this.$emit('update')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.text-right {
  text-align: right;
  font-size: 14px;
  line-height: 32px;
  padding-right: 20px;
}
</style>